import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";

import PreLoginReducer from "./Reducers/PreLoginState";
import LoginReducer from "./Reducers/LoginState";
import TopNavReducer from "./Reducers/TopNavbarState";
import DashboardReducer from "./Reducers/DashboardState";
import AppointmentsReducer from "./Reducers/AppointmentsState";
import BillingReducer from "./Reducers/BillingState";
import DocumentsReducer from "./Reducers/DocumentsState";
import HealthProfileReducer from "./Reducers/HealthProfileState";
import MembershipReducer from "./Reducers/MembershipState";
import HomeWorkReducer from "./Reducers/HomeWorkState";
import MessengerReducer from "./Reducers/MessengerState";
import SettingReducer from "./Reducers/SettingState";
import InsuranceReducer from "./Reducers/InsuranceState";
import PatientStatementDocsReducer from "./Reducers/PatientStatementDocsState";
import LifestyleReducer from "./Reducers/LifestyleState";
import RefundReducer from "./Reducers/RefundState";

import RootSaga from "../MiddleWare";

const Saga = createSagaMiddleware();
const store = configureStore({
  reducer: {
    PreLogin: PreLoginReducer,
    Login: LoginReducer,
    TopNavbar: TopNavReducer,
    Dashboard: DashboardReducer,
    Appointments: AppointmentsReducer,
    Billing: BillingReducer,
    Document: DocumentsReducer,
    HealthProfile: HealthProfileReducer,
    Membership: MembershipReducer,
    Refund: RefundReducer,
    HomeWork: HomeWorkReducer,
    Setting: SettingReducer,
    Messenger: MessengerReducer,
    Insurance: InsuranceReducer,
    PatientStatementDocs: PatientStatementDocsReducer,
    Lifestyle: LifestyleReducer,
  },
  devTools: process.env.NODE_ENV === "development",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
    }).concat(Saga),
});

Saga.run(RootSaga);

export default store;
